export default "__VITE_ASSET__b6050883__"